<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>

        <div class="row">
            <div class="col-sm-12 form-group">
                <label for="buscacns">CNS</label>
                <input class="form-control" :value="dados.pacienteReguladoCns" disabled>
            </div>
        </div>

        <b-alert variant="danger" :show="errorCns != null ? true : false">
             {{errorCns}}
        </b-alert>

        <div class="bordas" v-if="cnsInternacao != null">
            <div class="row">
                <div class="col-sm-12 form-group">
                    <label>Nome</label>
                    <input class="form-control" disabled :value="cnsInternacao.dados.nomeCompleto">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 form-group d-flex flex-column justify-content-end">
                    <label>CPF</label>
                    <input class="form-control" disabled :value="cnsInternacao.dados.cpf">
                </div>

                <div>
                    <label>Cód. Solicitação</label>
                    <input class="form-control" disabled :value="dados.codigoSolicitacao">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 form-group">
                    <label>Data de Nascimento</label>
                    <input class="form-control" disabled :value="nascimento">
                </div>
                <div class="col-sm-3 form-group">
                    <label>Idade</label>
                    <input class="form-control" disabled :value="cnsInternacao.dados.idade">
                </div>
                <div class="col-sm-3 form-group">
                    <label>Sexo</label>
                    <input class="form-control" disabled :value="cnsInternacao.dados.sexo">
                </div>
            </div>

            <div class="row">
                  <div class="col-sm-6 form-group">
                    <label to="data-picker">Data Admissão</label>
                    <datepicker
                        v-model="data_internacao_semformatacao"
                        :format="formatoData"
                        :disabled="dateDisabled"
                        language="pt-br"
                        id="data-picker"
                        calendar-button
                        calendar-button-icon="fa fa-calendar"
                        >
                    </datepicker>
                </div>

                <div class="col-sm-6 form-group">
                    <label>Hora Admissão</label>
                    <input class="form-control" type="time" v-model="hora">
                    <small v-if="hora == ''" class="text-danger">preenchimento obrigatório</small>
                </div>
            </div>

            <p v-if="dados.dataHoraRegulacao != ''">Data/Hora da Regulação: {{dados.dataHoraRegulacao}}</p>

            <button :disabled="hora.length < 5 ? true : false" type="button" class="btn btn-primary" @click.once="validaSessao('internaPacienteRegulado')">Realizar Admissão</button>
        
        </div>


    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import { captcha } from '../../../shared/mixins/captcha'
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    mixins: [
        captcha,
        validaSessao
    ],
    props: {
        dados: Object
    },
    components: {
        Datepicker
    },
    mounted () {
        let hora = new Date().getHours()
        let min = new Date().getMinutes()
        if (hora < 10) hora = '0' + hora
        if (min < 10) min = '0' + min
        
        this.hora = hora + ':' +  min
        
        // console.log(this.dados.leitoStatus)
        if (this.dados.leitoStatus == '4') this.refreshTokenCallMethod('censo_buscaCns', 'buscaCns')

        this.desabilitaDatas()
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        errorCns () {
            return this.$store.getters['consultas/getErrorCns']
        },
        cnsInternacao () {
            return this.$store.getters['consultas/getCnsInternacao']
        },
        token_captcha () {
            return this.$store.getters['sessao/getCaptcha']
        },
        nascimento () {
            if (this.cnsInternacao) return this.cnsInternacao.dados.dataNascimento.substr(8,2) + '/' + this.cnsInternacao.dados.dataNascimento.substr(5,2) + '/' +  this.cnsInternacao.dados.dataNascimento.substr(0,4)
            else  return ''
        }
    },
    data () {
        return {
            hora: '',
            formatoData: 'dd/MM/yyyy',
            data_internacao_semformatacao: new Date(),
            dateDisabled: {
                ranges: [
                    {
                        from: new Date(1990, 11, 25),
                        to: new Date(1990, 11, 25)
                    },
                    {
                        from: new Date(),
                        to: new Date(2040, 2, 25)
                    }
                ]
            }
        }
    },
    methods: {
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        buscaCns () {
            this.$store.dispatch('consultas/buscaCnsInternacao',  {
                tpDocumento: 'cns',
                documento: this.dados.pacienteReguladoCns,
                captcha: this.token_captcha
            })
        },
        desabilitaDatas () {
            if (this.dados.dataHoraRegulacao !== null && this.dados.dataHoraRegulacao !== '') {
                let ultimaMovimentacao = this.dados.dataHoraRegulacao
                let dia = parseInt(ultimaMovimentacao.substr(0,2))
                let mes = parseInt(ultimaMovimentacao.substr(3,2)) - 1
                let ano = parseInt(ultimaMovimentacao.substr(6,4))
                this.dateDisabled.ranges[0]['to'] = new Date(ano, mes,dia)
            }
        },
        internaPacienteRegulado () {
            if (this.hora.length < 5) return

            let datahora = this.formatadata(this.data_internacao_semformatacao) + ' ' + this.hora

            let dados = {
                cns: this.dados.pacienteReguladoCns,
                codigoEnfermaria: this.dados.leitoCodigoEnfermaria,
                codigoLeito: this.dados.leitoCodigo,
                dataHoraInternacao: datahora
            }

            this.$emit('internar', dados)
        }
    }
}
</script>

<style>
    
</style>